import * as requestTypes from './requestTypes'
import {Transaction} from '../data/Transaction'

export const abort = (optional = {}) => ({
    method: requestTypes.ABORT,
    params: optional,
})

export const check = (receipt_id, transaction: Transaction, optional = {}) => ({
    method: requestTypes.CHECK,
    params: {
        amount: Math.round(Math.abs(transaction.amount) * 100),
        currency: transaction.currency,
        receipt_id,
        sequence_id: transaction.id,
        external_data: transaction.toJS(),
        ...optional,
    },
})

export const print = (image, eject = true) => ({
    method: requestTypes.PRINT,
    params: {
        eject,
        image: {
            format: 'png',
            data: image,
        },
    },
})

export const purchase = (receipt_id, transaction: Transaction, optional = {}) => ({
    method: requestTypes.PURCHASE,
    params: {
        amount: Math.round(transaction.amount * 100),
        currency: transaction.currency,
        receipt_id,
        sequence_id: transaction.id,
        external_data: transaction.toJS(),
        ...optional,
    },
})

export const refund = (receipt_id, transaction: Transaction, optional = {}) => ({
    method: requestTypes.REFUND,
    params: {
        amount: Math.round(transaction.amount * -100),
        currency: transaction.currency,
        receipt_id,
        sequence_id: transaction.id,
        external_data: transaction.toJS(),
        ...optional,
    },
})

export const status = (optional = {}) => ({
    method: requestTypes.STATUS,
    params: optional,
})

export const terminalInfo = (optional = {}) => ({
    method: requestTypes.TERMINAL_INFO,
    params: optional,
})
